export default "__VITE_ASSET__C56W1xcu__"